<div class="space-y-2">
  <div
    class="course-image rounded-lg shadow-md overflow-hidden group-hover:shadow-xl transition-shadow duration-300"
  >
    <div class="aspect-w-16 aspect-h-9">
      <img
        class="object-cover w-full h-full rounded-lg duration-300"
        [src]="live?.thumb_path || 'assets/images/no-image.jpg'"
        [alt]="live?.title || 'No image available'"
        loading="lazy"
      />
    </div>
  </div>
  <div class="space-y-1 text-center">
    <p class="text-xs text-gray-600">
      <span class="font-bold uppercase"> {{ live?.title ?? '' }}</span
      ><br /><span class="uppercase">{{ live?.code }}</span>
      <span *ngIf="showDate">
        <br />
        Activity Date: {{ formatDate(live?.release_date) }}
      </span>
    </p>
  </div>
</div>
